import styled from 'styled-components';
import {header} from '../../../component/rightHeader/RightHeader.css';
import {table, tableContainer} from '../../../component/newTable/Table.css';
import {getSpacing} from '@tickchak/react-share/app';
import {wrapper as AnotherOneHorizontalWrapper} from '../../../component/anotherOneHorizontal/AnotherOneHorizontal.css';
import {laptopMedia, mobileMedia, scrollbar} from '../../../globalVariables/GlobalVariables';

export const wrapper = styled.div<{isCardView?: boolean}>`
    height: calc(100% - 100px);
    width: 100%;
    ${header}{
        display: none;
    }
    ${tableContainer}{
        height: calc(100% - 100px);
    }
    ${table}{
        ${laptopMedia}{
            min-width: 1000px;
            width: 100%;
        }
    }
    ${p => p.isCardView && `
        padding-block: ${getSpacing('spaceMd')};
        ${scrollbar};
    `}
    ${AnotherOneHorizontalWrapper}{
        width: 100%;
        max-width: 100%;
    }
`;

export const cardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(356px, 1fr));
    gap: ${getSpacing('spaceLg')};
    width: 100%;
    ${mobileMedia}{
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }
`;
